import AllanProfile from "../../image/allan.jpg";
import JulioProfile from "../../image/julio.jpeg";

import OlgaProfile from "../../image/olga.jpg";
import InacioProfile from "../../image/inacio.jpeg";
const devs = [
  {
    id: 1,
    name: "Allan Alves",
    description:
      "Meu nome é Allan, tenho 19 anos, comecei a estudar desenvolvimento web no ano de 2021.Gosto de desenvolver na parte do front-end, procuro sempre desafios e estou sempre aberto para aprender e trabalhar em equipe.Acesse minhas redes abaixo!!",
    office: "Tech-Leader",
    profile: AllanProfile,
    social: {
      linkedin: "https://www.linkedin.com/in/allan-alves-19b64a1b5/",
      github: "https://github.com/allanalvescs",
      instagram: "https://www.instagram.com/allan.17alves/",
    },
  },
  {
    id: 2,
    name: "Julio Barbosa",
    description:
      "Meu nome é Julio, tenho 25 anos, gosto da parte de desenvolvimento WEB, pretendo me especializar em desenvolvimento front-end",
    office: "QA",
    profile: JulioProfile,
    social: {
      linkedin:
        "https://www.linkedin.com/in/julio-cesar-barbosa-da-silva-b335b6100/",
      github: "https://github.com/JulioBarbosa19",
      instagram: "https://www.instagram.com/julio.barbosa.52/",
    },
  },
  {
    id: 3,
    name: "Cláudio Inácio",
    description:
      "Meu nome é Cláudio Inácio, tenho 27 anos, me apaixonei pelo desenvolvimento front-end desde que comecei a estudar em 2021, após finalizar o curso de front-end vou começar o novo desafio de me especializar em Desenvolvimento Mobile. Acesse minhas redes sociais abaixo!!",
    office: "Scrum Master",
    profile: InacioProfile,
    social: {
      linkedin:
        "https://www.linkedin.com/in/claudio-in%C3%A1cio-felipe-junior/",
      github: "https://github.com/claudio-inacio",
      instagram: "https://www.instagram.com/c.inaciio/",
      }
    },
    {
     id: 4,
    name: "Olga Luisa",
    description:
      "Meu nome é Olga Luisa, tenho 25 anos e sou apaixonada por tecnologia, desde nova sempre soube que era esse o caminho que eu queria seguir. Amo trabalhar na parte visual do projeto,gosto de aprender coisas novas mesmo que sejam desafiadoras e estou sempre aberta para novos aprendizados.",
    office: "PO",
    profile: OlgaProfile,
    social: {
      linkedin: "https://www.linkedin.com/in/olga-luisa-a63409196/",
      github: "https://github.com/Olgaluiisa",
      instagram: "https://instagram.com/olgaluiisa?igshid=YmMyMTA2M2Y=",
      }
    }
];

export default devs;
